import { Dialog, DialogActions, DialogTitle, Button, DialogContent } from '@mui/material';
import { MutableRefObject, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseMaintenanceForm from '../../../inventory/Ticketing/maintenance/CloseMaintenanceForm';
import { maintenanceService } from 'services/api';
import { IMaintenance } from 'interfaces';

interface CloseMaintenanceDialogProps {
  closeDialog?: () => void;
  open?: boolean;
  datagridRefresh?: MutableRefObject<any>;
  id?: number;
  maintenance?: IMaintenance | null;
}

export default function CloseMaintenanceDialog(params: CloseMaintenanceDialogProps) {
  const { datagridRefresh, id, maintenance: maintenanceProp, closeDialog, open } = params;
  const { t } = useTranslation();
  const translationPrefix = 'entities.equipment';

  const [maintenance, setMaintenance] = useState<IMaintenance | null>(maintenanceProp ?? null);

  useEffect(() => {
    if (maintenanceProp) {
      setMaintenance(maintenanceProp);
      return;
    }
    if (open && id && !maintenanceProp) {
      maintenanceService.get(id).then(setMaintenance);
      return;
    }
    if (!open) {
      setMaintenance(null);
    }
  }, [maintenanceProp, open, id]);

  const closeMaintenance = (values) => {
    const maintenanceId = maintenance?.id ?? id;
    if (!maintenanceId) {
      return;
    }
    maintenanceService.closeMaintenance(maintenanceId, values).then(() => {
      datagridRefresh.current();
    });
    closeDialog();
  };

  const formKey =
    open && maintenance ? `close-maintenance-${maintenance.id}` : 'close-maintenance-closed';

  return (
    <>
      <Dialog open={open} maxWidth="lg" fullWidth>
        <DialogTitle>{t(`${translationPrefix}.close`)}</DialogTitle>
        <DialogContent>
          <CloseMaintenanceForm
            key={formKey}
            onSubmit={closeMaintenance}
            maintenance={maintenance}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="error">
            {t('actions.cancel')}
          </Button>
          <Button type="submit" form="closeMaintenance">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
